import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { BusinessTripGetListEffect } from './business-trip-get-list.effect';
import { businessTripGetListReducer } from './business-trip-get-list.reducer';
import { BUSINESS_TRIP_GET_LIST_STORE_NAME, BusinessTripGetListState } from './business-trip-get-list.state';

/** Token of the BusinessTripGetList reducer */
export const BUSINESS_TRIP_GET_LIST_REDUCER_TOKEN = new InjectionToken<ActionReducer<BusinessTripGetListState, Action>>(
  'Feature BusinessTripGetList Reducer'
);

/** Provide default reducer for BusinessTripGetList store */
export function getDefaultBusinessTripGetListReducer() {
  return businessTripGetListReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(BUSINESS_TRIP_GET_LIST_STORE_NAME, BUSINESS_TRIP_GET_LIST_REDUCER_TOKEN),
    EffectsModule.forFeature([BusinessTripGetListEffect]),
  ],
  providers: [{ provide: BUSINESS_TRIP_GET_LIST_REDUCER_TOKEN, useFactory: getDefaultBusinessTripGetListReducer }],
})
export class BusinessTripGetListStoreModule {
  public static forRoot<T extends BusinessTripGetListState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<BusinessTripGetListStoreModule> {
    return {
      ngModule: BusinessTripGetListStoreModule,
      providers: [{ provide: BUSINESS_TRIP_GET_LIST_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
